export class SystemNotification {
  id: number;
  message = '';
  startTime: Date;
  endTime: Date;
  addedBy: string;
  addedDate: Date;
  modifiedDate: Date;
  modifiedBy: string;
  orgId: number;
  orgLevels: number[];
  showAtLoginPage: boolean;
  showAtNotificationCenter: boolean;
  organization: string;
  parentNotification: number;
  sentTime: Date;
  subject: string;
  followUps: SystemNotificationFollowUp[];

  markets: string;
  isUnread = false;
}

export class SystemNotificationFollowUp {
  id: number;
  message = '';
  parentId: number;
  addedDate: Date;
  isUnread = false;
}

export class SystemNotificationApiResponse {
  currentNotifications: SystemNotification[];
  pastNotifications: SystemNotification[];
  upcomingNotifications: SystemNotification[];
}

export enum NotificationLocation {
  LOGIN_PAGE = 'LOGIN_PAGE',
  NOTIFICATION_CENTER = 'NOTIFICATION_CENTER'
}

export interface NotificationLocationConfigItem {
  id: number;
  description: string;
}

export const NOTIFICATION_LOCATION_CONFIG: { [key in NotificationLocation]: NotificationLocationConfigItem } = {
  [NotificationLocation.LOGIN_PAGE]: {
    id: 1,
    description: 'Login Page'
  },
  [NotificationLocation.NOTIFICATION_CENTER]: {
    id: 2,
    description: 'Notification Center'
  }
};
